import { bcEnums } from 'common/common/constants/boldchat-enums';

export const accessibilitySettingsConfig = [
  {
    name: bcEnums.accessibilitySettingNames.CONVERSATION_FONT_SIZE,
    title: 'accesibilitySettings.textSizeForConversations',
    isTurnedOn: false
  }
];
